var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"百信"}},[_c('BaixinData',{ref:"BaixinData"})],1),_c('TabPane',{attrs:{"label":"畅开花"}},[_c('ChangkaihuaData',{ref:"ChangkaihuaData"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }